// Estados do Brasa, o vaga-lume do onboarding. A folha de personagem aprovada
// (.hermes/mockups/2026-08-23-brasa-folha-de-personagem.html) e a referencia
// visual de cada um; o GuidedTour mapeia momento do tour -> estado.
export const BRASA_STATES = [
  'idle',
  'fly',
  'hover',
  'land',
  'point',
  'inspect',
  'celebrate',
  'sleep',
  'wave',
  'wait',
  'nudge',
  'droop',
];

// Rumo (0 = cima, horario) do ponto `from` ate o ponto `to`, em graus.
export function bearingBetween(from, to) {
  let deg = (Math.atan2(to.x - from.x, -(to.y - from.y)) * 180) / Math.PI;
  if (deg < 0) deg += 360;
  return deg;
}
